import { render } from "./ConversationHeader.vue?vue&type=template&id=dea98226&ts=true"
import script from "./ConversationHeader.ts?vue&type=script&lang=ts&external"
export * from "./ConversationHeader.ts?vue&type=script&lang=ts&external"

import "./ConversationHeader.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__